import React, {Component} from 'react';
import {Nav, NavItem, NavLink} from 'reactstrap';
import {Link as RouterLink, withRouter} from 'react-router-dom';
import './AppSideNav.scss';

class AppSideNav extends Component {

  constructor(props) {
    super(props);

    this.navItem = this.navItem.bind(this);
  }

  navItem({icon, activeIcon, mobileIcon, to, label, exact = false}) {
    let {location} = this.props;
    let pathRegex = new RegExp(`^${to}` + (exact ? '$' : ''));
    let isActive = pathRegex.test(location.pathname);
    return (
        <NavItem active={isActive} className="d-flex align-items-center">
          <img className="show"
               src={process.env.PUBLIC_URL + '/img/' + icon}
               height={24}
               alt="Home"/>
          <img className="hide"
               src={process.env.PUBLIC_URL + '/img/' + activeIcon}
               height={24}
               alt="Home"/>
          <img className="mobile"
               src={process.env.PUBLIC_URL + '/img/' + mobileIcon}
               height={24}
               alt="Home"/>
          <RouterLink to={to} className="nav-link">{label}</RouterLink>
        </NavItem>
    );
  }

  render() {
    return (
        <div className="BlockAppSideNav">
          <nav className="nav-bar">
            <div className="enumenu_container">
              <Nav vertical className="enumenu_ul menu desk">
                {this.navItem({
                  icon: 'home.svg',
                  activeIcon: 'home-active.svg',
                  mobileIcon: 'home-mobile.svg',
                  to: '/',
                  label: 'Home',
                  exact: true,
                })}
                {this.navItem({
                  icon: 'submit.svg',
                  activeIcon: 'submit-active.svg',
                  mobileIcon: 'submit-mobile.svg',
                  to: '/blueprints/submit',
                  label: 'Submit Document',
                })}
                {this.navItem({
                  icon: 'review.svg',
                  activeIcon: 'review-active.svg',
                  mobileIcon: 'review-mobile.svg',
                  to: '/blueprints/review',
                  label: 'Review Document',
                })}
                {this.navItem({
                  icon: 'discussion.svg',
                  activeIcon: 'discussion-active.svg',
                  mobileIcon: 'discussion-mobile.svg',
                  to: '/discussions',
                  label: 'Discussions',
                })}
                {this.navItem({
                  icon: 'faq.svg',
                  activeIcon: 'faq-active.svg',
                  mobileIcon: 'faq-mobile.svg',
                  to: '/faq',
                  label: 'FAQ',
                })}
              </Nav>
            </div>
          </nav>
        </div>
    );
  }
}

export default withRouter(AppSideNav);


// WEBPACK FOOTER //
// ./src/blocks/AppSideNav.js